// extracted by mini-css-extract-plugin
export default {"live-message":"live-messages_live-message__7z5sq","ask-error-message":"live-messages_ask-error-message__uM5dn"};